var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHippoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.11732 7.97393C4.04598 7.54783 3.28784 6.50111 3.28784 5.2787C3.28784 3.67854 4.58698 2.37939 6.18714 2.37939C7.41345 2.37939 8.46297 3.14241 8.88645 4.21916",
    stroke: "#201D1D",
    strokeWidth: 2,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1347 4.16688C23.5712 3.11779 24.6065 2.37939 25.8129 2.37939C27.413 2.37939 28.7122 3.67854 28.7122 5.2787C28.7122 6.50111 27.954 7.54783 26.8827 7.97393",
    stroke: "#201D1D",
    strokeWidth: 2,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.21382 11.8178C5.21382 7.88895 8.56208 4.57525 13.1175 3.57449C14.0352 3.37288 15.0019 3.26514 16 3.26514C21.9531 3.26514 26.7863 7.09747 26.7863 11.8178",
    stroke: "#201D1D",
    strokeWidth: 2,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7609 13.8054C18.7609 15.3679 20.3969 16.3089 21.9594 16.3089C27.1718 16.3089 28.6867 20.0241 28.6867 23.2344C28.6867 26.4447 26.356 29.621 22.1923 29.621C19.871 29.621 18.321 28.6087 16 28.5686C13.6791 28.6087 12.1291 29.621 9.80783 29.621C5.64407 29.621 3.31343 26.4447 3.31343 23.2344C3.31343 20.0241 4.82829 16.3089 10.0407 16.3089C11.6032 16.3089 13.2392 15.3679 13.2392 13.8054",
    stroke: "#201D1D",
    strokeWidth: 2,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.41196 10.7873C9.68888 10.2105 10.3001 9.70424 11.0935 9.47054C11.8583 9.24524 12.6182 9.3246 13.1605 9.63029",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.41196 10.7873C9.68888 10.2105 10.3001 9.70424 11.0935 9.47054C11.8583 9.24524 12.6182 9.3246 13.1605 9.63029",
    stroke: "#201D1D",
    strokeWidth: 2,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5881 10.7873C22.3112 10.2105 21.6999 9.70424 20.9066 9.47054C20.1418 9.24524 19.3819 9.3246 18.8396 9.63029",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5881 10.7873C22.3112 10.2105 21.6999 9.70424 20.9066 9.47054C20.1418 9.24524 19.3819 9.3246 18.8396 9.63029",
    stroke: "#201D1D",
    strokeWidth: 2,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.50376 23.9903C10.6577 23.9903 11.5932 23.0549 11.5932 21.9009C11.5932 20.747 10.6577 19.8115 9.50376 19.8115C8.34981 19.8115 7.41435 20.747 7.41435 21.9009C7.41435 23.0549 8.34981 23.9903 9.50376 23.9903Z",
    stroke: "#201D1D",
    strokeWidth: 2,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4963 23.9903C23.6503 23.9903 24.5857 23.0549 24.5857 21.9009C24.5857 20.747 23.6503 19.8115 22.4963 19.8115C21.3424 19.8115 20.4069 20.747 20.4069 21.9009C20.4069 23.0549 21.3424 23.9903 22.4963 23.9903Z",
    stroke: "#201D1D",
    strokeWidth: 2,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHippoIcon);
export default __webpack_public_path__ + "static/media/hippoIcon.c90760a3de3be73101e782f23c231543.svg";
export { ForwardRef as ReactComponent };